import beepSound from '../assets/beep.mp3';

/**
 * Helper function to emit a beep sound in the browser using an Audio File.
 *
 * @param {number} volume - The volume of the beep sound.
 *
 * @returns {Promise} - A promise that resolves when the beep sound is finished.
 */
function beep(volume){
    return new Promise((resolve, reject) => {
        volume = volume || 70;

        try{
            // You're in charge of providing a valid AudioFile that can be reached by your web app
            let sound = new Audio(beepSound);

            // Set volume
            sound.volume = volume / 100;

            sound.onended = () => {
                resolve();
            };

            sound.play();
        }catch(error){
            reject(error);
        }
    });
}

export default beep;
